(function () {
  if (window.__kfgSiteCartFixLoaded) return;
  window.__kfgSiteCartFixLoaded = true;

  console.log('[KFG site cart fix] loaded');

  function getRootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getSiteCartSidebar() {
    return document.getElementById('site-cart-sidebar');
  }

  function getVariantId(form) {
    var part = form.closest('.kfg__part');

    if (part && part.getAttribute('data-variant-id')) {
      return part.getAttribute('data-variant-id');
    }

    var idInput = form.querySelector('input[name="id"], select[name="id"]');

    if (idInput && idInput.value) {
      return idInput.value;
    }

    return null;
  }

  function openSiteCartSidebar() {
    var sidebar = getSiteCartSidebar();

    if (!sidebar) {
      console.warn('[KFG site cart fix] site-cart-sidebar not found.');
      return;
    }

    if (typeof sidebar.show === 'function') {
      sidebar.show();
      return;
    }

    sidebar.style.display = 'block';
    sidebar.removeAttribute('hidden');
  }

  async function refreshSiteCartSidebar() {
    try {
      var response = await fetch(window.location.pathname + window.location.search, {
        method: 'GET',
        credentials: 'same-origin'
      });

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var currentSidebar = document.getElementById('site-cart-sidebar');
      var newSidebar = doc.getElementById('site-cart-sidebar');

      if (currentSidebar && newSidebar) {
        currentSidebar.innerHTML = newSidebar.innerHTML;

        if (newSidebar.getAttribute('data-cart-items')) {
          currentSidebar.setAttribute('data-cart-items', newSidebar.getAttribute('data-cart-items'));
        }

        currentSidebar.className = newSidebar.className;
      }

      var currentCartTrigger = document.querySelector('[aria-controls="site-cart-sidebar"]');
      var newCartTrigger = doc.querySelector('[aria-controls="site-cart-sidebar"]');

      if (currentCartTrigger && newCartTrigger) {
        currentCartTrigger.innerHTML = newCartTrigger.innerHTML;
        currentCartTrigger.className = newCartTrigger.className;

        Array.from(newCartTrigger.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-') === 0 || attr.name === 'aria-label') {
            currentCartTrigger.setAttribute(attr.name, attr.value);
          }
        });
      }
    } catch (error) {
      console.error('[KFG site cart fix] Cart sidebar refresh failed:', error);
    }
  }

  async function addKonfigPart(form, button) {
    if (!form || form.dataset.kfgBusy === 'true') return;

    var variantId = getVariantId(form);

    if (!variantId) {
      console.warn('[KFG site cart fix] Variant ID not found.');
      return;
    }

    form.dataset.kfgBusy = 'true';

    var originalText = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      console.log('[KFG site cart fix] Adding variant:', variantId);

      var response = await fetch(getRootUrl() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      var result = await response.json();

      if (!response.ok) {
        throw result;
      }

      await refreshSiteCartSidebar();

      openSiteCartSidebar();

      if (button) {
        button.textContent = 'Added';

        setTimeout(function () {
          button.textContent = originalText || 'Add to Cart';
          button.disabled = false;
        }, 900);
      }
    } catch (error) {
      console.error('[KFG site cart fix] Add to cart failed:', error);

      if (button) {
        button.textContent = 'Try Again';
        button.disabled = false;
      }
    }

    setTimeout(function () {
      form.dataset.kfgBusy = 'false';
    }, 500);
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.kfg__form button, .kfg__form [type="submit"]');

      if (!button) return;

      var form = button.closest('.kfg__form');

      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addKonfigPart(form, button);

      return false;
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('.kfg__form');

      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var button = form.querySelector('button, [type="submit"]');

      addKonfigPart(form, button);

      return false;
    },
    true
  );
})();

document.addEventListener(
  'click',
  function (event) {
    var closeButton = event.target.closest('#site-cart-sidebar [data-js-close]');

    if (!closeButton) return;

    var sidebar = document.getElementById('site-cart-sidebar');

    if (!sidebar) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof sidebar.hide === 'function') {
      sidebar.hide();
      return;
    }

    if (typeof sidebar.close === 'function') {
      sidebar.close();
      return;
    }

    sidebar.style.display = 'none';
    sidebar.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  },
  true
);